export const TaskStatusTypes = Object.freeze({
    ASSIGNED: 1,
    COMPLETED:2,
    APPROVED:3,
    DECLINED:4,
    REASSIGNED: 5,
    PUBLISHED: 6,
    COMMENT: 7,
    CANCELLED:8,
    INPROGRESS: 9,
    PENDINGREVIEW: 10,
    PENDINGAPPROVAL: 11
})